import React from 'react';
import './banner.css';
const Banner = () => {
  return (
    <div className="mr-rupya-hero-canvas">
      <div className="animated-glow-orb-one"></div>
      <div className="animated-glow-orb-two"></div>
      <div className="fintech-matrix-grid"></div>

      <div className="hero-structural-grid">
        <div className="grid-content-left animate-fade-in-left">
          <div className="premium-context-badge">
            <span className="badge-pill-line"></span>
            <span className="badge-pill-text">ULTRA SHORT TERM LOAN ONLINE</span>
          </div>

          <h1 className="main-hero-headline">
            SMART LOAN <br />
            <span className="teal-gradient-text">SOLUTIONS</span>
          </h1>

          <p className="main-hero-subtext">
            Empowering your financial future through high-fidelity automation,
            seamless digital processing, and instant micro-approvals.
          </p>

          <div className="hero-quick-bar">
            
            <ul className="hero-trust-pills" aria-label="Key benefits">
              <li>Paperless process</li>
              <li>Quick approval</li>
              <li>Secure &amp; encrypted</li>
            </ul>
          </div>
        </div>

        <div className="grid-content-right">
          <div className="interactive-scene-wrapper">
            <div className="moving-vector-ring"></div>

            <div className="master-glass-card animate-float-delayed">
              <div className="card-chip-row">
                <div className="emv-chip"></div>
                <div className="card-brand-sign">MR</div>
              </div>
              <div className="card-balance-metric">
                <span className="metric-caption">Available Limit</span>
                <h3 className="metric-amount">₹1,00,000</h3>
              </div>
              <div className="card-footer-details">
                <span className="card-holder-name">LOAN CARD</span>
                <span className="card-expiry-date">
                  <span className="card-valid-label">Tenure</span>
                  7–365 DAYS
                </span>
              </div>
            </div>

            <div className="floating-widget-badge widget-status animate-float">
              <div className="status-pulse-dot"></div>
              <div className="widget-text-group">
                <span className="widget-label">Loan Disbursal</span>
                <span className="widget-value-green">Instant Approved</span>
              </div>
            </div>

            <div className="floating-widget-badge widget-security animate-float-reverse">
              <div className="security-icon-shield">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#00B4D8"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </div>
              <div className="widget-text-group">
                <span className="widget-label">Security Protocol</span>
                <span className="widget-value-dark">256-Bit Encrypted</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
